// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-style[data-v-53031532]{background-color:rgba(131,125,137,.3)}.make-blue[data-v-53031532]{color:#00f}", ""]);
// Exports
module.exports = exports;
